import '/src/utils/fontSize.js'

import { createApp } from 'vue'
import App from './index.vue'

import { intersectDirective } from '/src/utils/intersect.js'
import '@arco-design/web-vue/dist/arco.css' // 必须引入样式

import i18n from '@/i18n/index.js'

import JwtVerifierPlugin from '/src/utils/jwtVerifier'

const app = createApp(App)

// 安装插件
app.use(JwtVerifierPlugin, {
    autoInit: true,           // 自动初始化
    periodicCheck: true,     // 开启定期检查
    checkInterval: 120       // 每2小时检查一次
})


// 使用国际化
app.use(i18n)

// 全局注册指令
app.directive('intersect', intersectDirective)

app.mount('#header')